import {
  ApplicationConfig,
  importProvidersFrom,
  provideZoneChangeDetection,
} from "@angular/core";
import { provideRouter } from "@angular/router";

import { routes } from "./app.routes";
import {provideHttpClient, withInterceptors} from "@angular/common/http";
import { provideStore, provideState } from "@ngrx/store";
import { provideRouterStore, routerReducer } from "@ngrx/router-store";
import { provideEffects } from "@ngrx/effects";
import { authReducer } from "./state/auth/auth.reducer";
import * as authEffects from "./state/auth/auth.effects";
import * as networkEffects from "./state/network/network.effects";
import * as entityEffects from "./state/entities/entity.effects";
import * as usersEffects from "./state/users/users.effects";
import * as chatEffects from "./state/chats/chat.effects"
import * as cameraEffects from "./state/camera/camera.effects";
import * as instanceEffects from "./binst/world/instance-service/instance.effects"
import * as worldEffects from "./state/world/world.effects";
import {
  provideStoreDevtools,
  StoreDevtoolsModule,
} from "@ngrx/store-devtools";
import { isDevMode } from "@angular/core";
import { networkReducer } from "./state/network/network.reducer";
import { cameraReducer } from "./state/camera/camera.reducer";
import { entityReducer } from "./state/entities/entity.reducer";
import { worldReducer } from "./state/world/world.reducer";
import { interfaceReducer } from "./state/interface/interface.reducer";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import {AuthHttpInterceptor} from "./auth/services/auth-http-interceptor";
import {clearStateMetaReducer} from "./state/auth/logout.metareducer";
import {reactionsReducer} from "./state/reactions/reactions.reducer";
import {usersReducer} from "./state/users/users.reducer";
import {chatReducer} from "./state/chats/chat.reducer";
import { provideServiceWorker } from '@angular/service-worker';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';

export const appConfig: ApplicationConfig = {
  providers: [
    importProvidersFrom(BrowserAnimationsModule),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideHttpClient(
        withInterceptors([AuthHttpInterceptor])
    ),
    provideStore({
      router: routerReducer,
    },
    {
      metaReducers: [clearStateMetaReducer] // <-- Add this here
    }),
    provideState({
      name: "auth",
      reducer: authReducer,
    }),
    provideState({
      name: "entity",
      reducer: entityReducer,
    }),
    provideState({
      name: "users",
      reducer: usersReducer,
    }),
    provideState({
      name: "reactions",
      reducer: reactionsReducer,
    }),
    provideState({
      name: "chats",
      reducer: chatReducer,
    }),
    provideState({
      name: "interface",
      reducer: interfaceReducer,
    }),
    provideState({
      name: "network",
      reducer: networkReducer,
    }),
    provideState({
      name: "camera",
      reducer: cameraReducer,
    }),
    provideState({
      name: "world",
      reducer: worldReducer,
    }),
    provideRouterStore(),
    provideEffects(authEffects),
    provideEffects(entityEffects),
    provideEffects(usersEffects),
    provideEffects(chatEffects),
    // provideEffects(interfaceEffects),
    provideEffects(networkEffects),
    // provideEffects(imagesEffects),
    provideEffects(instanceEffects),
    provideEffects(cameraEffects),
    provideEffects(worldEffects),
    provideStoreDevtools({
      maxAge: 800, // Retains last 25 states
      logOnly: !isDevMode(), // Restrict extension to log-only mode
      autoPause: true, // Pauses recording actions and state changes when the extension window is not open
      trace: true, //  If set to true, will include stack trace for every dispatched action, so you can see it in trace tab jumping directly to that part of code
      traceLimit: 175, // maximum stack trace frames to be stored (in case trace option was provided as true)
      connectInZone: true, // If set to true, the connection is established within the Angular zone
    }),
    provideServiceWorker('/custom-sw.js', {
      enabled: !isDevMode(),
      registrationStrategy: 'registerWithDelay:2000'
    }), provideAnimationsAsync(),
  ],
};
